import { Row, Col, Image, Button, Card } from 'react-bootstrap'
import { createClient } from 'graphqurl'
import Job from '../../../components/Job'
import Head from 'next/head'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { getCategoriesWithJobCountsQuery, processCategoriesWithCounts } from '../../../helpers/categories'
import { withIronSessionSsr } from 'iron-session/next'
import { sessionOptions } from '../../../lib/session'
import styles from '../../../styles/Company.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
	faChevronLeft,
	faChevronRight,
} from '@fortawesome/free-solid-svg-icons'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import Event104Company from '../../../components/Event/Event104Company'

const Company: React.FC = (props: any) => {
	const { t } = useTranslation()
	const router = useRouter()
	const locale: string = router.locale as string

	// Check if this is event 104 (Tech Talent)
	if (props.eventId === '104') {
		return <Event104Company {...props} />
	}

	const getPaginationLink = (page: string): string => {
		if (props.eventId !== null) {
			return `/${locale}/company/jobs/${props.companyId}-${props.eventId}?page=${page}&event=${props.eventId}`
		} else {
			return `/${locale}/company/jobs/${props.companyId}?page=${page}`
		}
	}
	const formatHTML = (text) => {
		if (!text) {
			return ''
		}
		return text
			.replace(/<\/b>/g, '\n')
			.replace(/<\/br>/g, '\n')
			.replace(/<\/p>/g, '\n')
			.replace(/(<([^>]+)>)/gi, '')
			.replace(/<p>\s<\/p>/g, '')
			.replace(/&lt;/g, '')
			.replace(/&gt;/g, '')
			.replace(/\t/g, '')
			.replace(/<ol>/g, '')
			.replace(/<\/ol>/g, '')
			.replace(/<li>/g, '')
			.replace(/<\/li>/g, '')
			.replace(/<p>/g, '')
			.replace(/<\/p>/g, '')
			.replace(/<div>/g, '')
			.replace(/<\/div>/g, '')
			.replace(/\r\n\r\n/g, '')
			.replace(/<ul>/g, '')
			.replace(/<\/ul>/g, '')
			.replace(/<br\s*[\/]?>/gi, '')
			.replace(/<span>/g, '')
			.replace(/<\/span>/g, '')
			.replace(/<hr>/g, '')
			.replace(/<\/hr>/g, '')
			.replace(/<b>/g, '')
			.replace(/<\/b>/g, '')
			.replace(/<strong>/g, '')
			.replace(/<\/strong>/g, '')
			.replace(/<pre>/g, '')
			.replace(/<\/pre>/g, '')
			.replace(/&nbsp;/g, ' ')
	}
	return (
		<>
			<Head>
				<title>{props.company.name} | Findjobs</title>
			</Head>
			<Row className="justify-content-center">
				<Col className="text-center">
					<br />
					<br />
					<div className="container d-flex">
						<div className={styles.imageContainer}>
							<Image
								className={styles.image}
								src={props.company.avatar}
								alt=""
							/>
						</div>
					</div>
					<br />
					<h2>{props.company.name}</h2>
					<br />
					<br />
				</Col>
			</Row>
			<Row>
				<Col
					style={{
						paddingRight: props.company.description !== null ? '0px' : '14px',
					}}
				>
					<a
						href={`/${locale}/company/jobs/${props.companyId}${props.eventId !== null
							? `-${props.eventId}?event=${props.eventId}`
							: ''
						}`}
					>
						<Button
							className={styles.btnTabLeft}
							size="lg"
							style={{
								backgroundColor: props.tab === 'jobs' ? 'gray' : 'white',
								color: props.tab === 'jobs' ? 'white' : 'black',
								borderTopRightRadius:
									props.company.description === null
										? '12px'
										: '0px !important',
							}}
						>
							{t('company.all_jobs')}
						</Button>
					</a>
				</Col>
				{props.company.description !== null && (
					<Col
						style={{
							paddingLeft: props.company.description !== null ? '0px' : '14px',
						}}
					>
						<a
							href={`/${locale}/company/about-us/${props.companyId}${props.eventId !== null
								? `-${props.eventId}?event=${props.eventId}`
								: ''
							}`}
						>
							<Button
								className={styles.btnTabRight}
								size="lg"
								style={{
									backgroundColor: props.tab === 'about-us' ? 'gray' : 'white',
									color: props.tab === 'about-us' ? 'white' : 'black',
								}}
							>
								{t('company.about_company')}
							</Button>
						</a>
					</Col>
				)}
			</Row>
			{props.tab === 'jobs' && (
				<>
					<Card className={styles.detailCard}>
						<Card.Body className={styles.detailCard}>
							{props.jobs.map((job: any, index: number) => {
								return (
									<div key={index}>
										<Job
											job={job}
											showAvatar={false}
											withBorder={false}
											query={
												props.eventId !== null
													? `event=${props.eventId as string}`
													: ''
											}
											isCompanyDetail={true}
										/>
										{index !== props.jobs.length - 1 && <hr />}
									</div>
								)
							})}
						</Card.Body>
					</Card>
					{props.jobs.length > 0 && props.jobAggregate.aggregate.count > 10 ? (
						<div className={`${styles.paginationContainer} mt-4`}>
							<nav aria-label="Page navigation example">
								<ul className="pagination justify-content-center pagination-md">
									<li
										className={
											props.pagination.prev ? 'page-item' : 'page-item disabled'
										}
									>
										<a
											className="page-link"
											href={getPaginationLink(
												(parseInt(props.page) - 1).toString(),
											)}
											aria-disabled="true"
										>
											<FontAwesomeIcon icon={faChevronLeft} width="12px" />
										</a>
									</li>
									{props.pagination.pagi.map((pagi, index) => {
										return (
											<li
												key={index}
												className={
													pagi === 'dotted'
														? 'page-item disabled'
														: pagi === parseInt(props.page)
															? 'page-item active'
															: 'page-item'
												}
											>
												<a
													className="page-link"
													href={getPaginationLink(pagi.toString())}
												>
													{pagi === 'dotted' ? '...' : pagi}
												</a>
											</li>
										)
									})}
									<li
										className={
											props.pagination.next ? 'page-item' : 'page-item disabled'
										}
									>
										<a
											className="page-link"
											href={getPaginationLink(
												(parseInt(props.page) + 1).toString(),
											)}
										>
											<FontAwesomeIcon icon={faChevronRight} width="12px" />
										</a>
									</li>
								</ul>
							</nav>
						</div>
					) : (
						<br />
					)}
				</>
			)}
			{props.tab === 'about-us' && props.company.description !== null && (
				<>
					<Card className={styles.detailCard}>
						<Card.Body className={styles.detailCard}>
							<pre className="p-1">{formatHTML(props.company.description)}</pre>
							{props.company.video !== null && props.company.video !== '' && (
								<div className="video-responsive">
									<iframe
										width="560"
										height="315"
										src={props.company.video}
										title="YouTube video player"
										frameBorder="0"
										allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
										allowFullScreen
									/>
								</div>
							)}
						</Card.Body>
					</Card>
				</>
			)}
		</>
	)
}

// This gets called on every request
export const getServerSideProps = withIronSessionSsr(
	async function getServerSideProps({ locale, query }) {
		const page =
			typeof query.page !== 'undefined' && parseInt(query.page as any)
				? parseInt(query.page as any)
				: 1
		let companyId = 0
		let eventId = 0
		if (typeof query.id !== 'undefined') {
			const id: string = query.id as string
			const splitId: any[] = id.split('-')
			companyId = splitId[0]
			eventId = splitId[1]
		}

		const client = createClient({
			endpoint: process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT as string,
			headers: {
				'X-Hasura-Admin-Secret': process.env.HASURA_ADMIN_SECRET as string,
			},
		})

		const isEvent104 = String(eventId) === '104'

		if (isEvent104) {
			const limit = 10

			// Build filters from query params
			const filters: any = {	
				jobCategories: typeof query.c !== 'undefined' ? (query.c as string).split(',').filter((el: string) => el !== '').map((cat: string) => parseInt(cat)) : [],
				jobOccupations: typeof query.o !== 'undefined' ? (query.o as string).split(',').filter((el: string) => el !== '').map((occ: string) => parseInt(occ)) : [],
				// jobLevels: typeof query.level !== 'undefined' ? (query.level as string).split(',').filter((el: string) => el !== '').map((level: string) => parseInt(level)) : [],
				jobTypes: typeof query.type !== 'undefined' ? (query.type as string).split(',').filter((el: string) => el !== '') : [],
				mrt: typeof query.mrt !== 'undefined' ? (query.mrt as string).split(',').filter((el: string) => el !== '') : [],
				keyword: typeof query.q !== 'undefined' ? query.q as string : '',
				minSalary: typeof query.minSalary !== 'undefined' ? parseInt(query.minSalary as string) : null,
				maxSalary: typeof query.maxSalary !== 'undefined' ? parseInt(query.maxSalary as string) : null,
			}

			const jobTypeMap: { [key: string]: string } = {
				'Permanent': 'FT',
				'Internship': 'INTERN'
			}
			let searchKeyword = filters.keyword
			if (filters.keyword && jobTypeMap[filters.keyword]) {
				searchKeyword = jobTypeMap[filters.keyword]
			}

			let whereClause = `companyId: {_eq: ${companyId}}, isAvailable: {_eq: true}, jobPostStart: {_lte: $date}, jobPostEnd: {_gte: $date}, eventID: {_eq: ${eventId}}, JobPlatforms: {platform: {_in: ["VCF"]}}`
			if (filters.jobCategories.length > 0) {
				whereClause += `, jobCategory: {_in: [${filters.jobCategories.join(',')}]}`
			}
			if (filters.jobOccupations.length > 0) {
				whereClause += `, jobOccupation: {_in: [${filters.jobOccupations.join(',')}]}`
			}
			// if (filters.jobLevels.length > 0) {
			// 	whereClause += `, jobLevel: {_in: [${filters.jobLevels.join(',')}]}`
			// }
			if (filters.jobTypes.length > 0) {
				whereClause += `, JobSalaries: {jobType: {_in: [${filters.jobTypes.map(t => `"${t}"`).join(',')}]} }`
			}
			if (filters.minSalary !== null || filters.maxSalary !== null) {
				let salaryClause = ', JobSalaries: {'
				if (filters.minSalary !== null) {
					salaryClause += `min: {_gte: ${filters.minSalary}}`
				}
				if (filters.maxSalary !== null) {
					if (filters.minSalary !== null) salaryClause += ', '
					salaryClause += `max: {_lte: ${filters.maxSalary}}`
				}
				salaryClause += '}'
				whereClause += salaryClause
			}
			if (filters.keyword) {
				whereClause += `, _or: [
					{title: {_ilike: "%${searchKeyword}%"}}, 
					{Occupation: {name: {_ilike: "%${searchKeyword}%"}}},
					{JobSalaries: {jobType: {_ilike: "%${searchKeyword}%"}}}
				]`
			}

			const jobQuery = `query($date: timestamptz!) {
				Job(where: {${whereClause}}, limit: ${limit}, offset: ${(page - 1) * limit}) {
					id
					title
					titleChinese
					titleMalay
					requirements
					vacancies
					createdAt
					jobPostStart
					eventID
					jobCategory
					jobOccupation
					JobHashTags {
						hashtag
						Hashtag {
							hashtag
							description
							color
						}
					}
					JobLocations {
						Branch {
							MrtStation {
								name
							}
						}
					}
					Company {
						name
						avatar
					}
					JobSalaries {
						min
						max
						jobType
						salaryType
					}
					Occupation {
						name
					}
					Category {
						name
					}
				}
				Job_aggregate(where: {${whereClause}}) {
					aggregate {
						count
					}
				}
				Company_by_pk(id: ${companyId}) {
					name
					description
					avatar
					video
				}
				MrtLine {
					id
					name
					colour
					MrtStations {
						id
						name
					}
				}
			}`
			const hasuraQuery = await client.query({
				query: jobQuery,
				variables: { date: new Date() },
			})
			const hasuraRes = await hasuraQuery
			const {
				data: {
					Company_by_pk: CompanyByPk,
					Job,
					Job_aggregate,
					MrtLine,
				},
			} = hasuraRes

			const categoriesQuery = await client.query({
				query: getCategoriesWithJobCountsQuery(104, companyId),
			})

			const { data: { Category: categoriesWithCounts } } = categoriesQuery

			const { categories, categoryJobCounts } = processCategoriesWithCounts(categoriesWithCounts)

			// Calculate pagination
			const jobAggregate = Job_aggregate
			const currentPage = page
			type Pagination = {
				prev: boolean;
				pagi: any[];
				next: boolean;
			};
			const pagination: Pagination = {
				prev: false,
				pagi: [],
				next: false,
			}
			if (currentPage > 1) {
				pagination.prev = true
			}

			const numOfPage = Math.ceil(jobAggregate?.aggregate?.count / limit)

			if (numOfPage < 6) {
				pagination.pagi = Array.from(Array(numOfPage), (e, i) => {
					return i + 1
				})
			} else {
				if (currentPage < 3) {
					pagination.pagi = Array.from(Array(3), (e, i) => {
						return i + 1
					})
					pagination.pagi.push('dotted')
					pagination.pagi.push(numOfPage)
				} else {
					const tempPagiItems: any[] = []

					if (currentPage - 1 > 1) {
						if (currentPage - 2 !== 1) {
							tempPagiItems.push(1)
							if (currentPage - 2 !== 1) {
								tempPagiItems.push('dotted')
							}
						}
					}

					if (currentPage - 1 > 1) {
						tempPagiItems.push(currentPage - 1)
					}

					tempPagiItems.push(currentPage)
					if (currentPage + 1 <= numOfPage) {
						tempPagiItems.push(currentPage + 1)
					}
					if (currentPage + 2 <= numOfPage) {
						if (currentPage + 2 !== numOfPage) {
							if (currentPage + 3 < numOfPage) {
								tempPagiItems.push('dotted')
							}
							tempPagiItems.push(numOfPage)
						}
					}

					pagination.pagi = tempPagiItems
				}
			}

			pagination.next = false
			if (currentPage < numOfPage) {
				pagination.next = true
			}

			return {
				props: {
					...(await serverSideTranslations(locale as string, ['common'])),
					companyId,
					jobs: Job,
					jobAggregate: Job_aggregate,
					company: CompanyByPk,
					eventId,
					categories,
					categoryJobCounts,
					mrtLine: MrtLine,
					filters,
					pagination,
					page,
				},
			} as any
		}

		let jobQuery = ''
		const limit = 10
		if (query.tab === 'jobs') {
			jobQuery = `query($date: timestamptz!) {
      Job(where: {companyId: {_eq: ${companyId}}, 
				${eventId !== undefined
		? 'isAvailable: {_eq: true}, jobPostStart: {_lte: $date}, jobPostEnd: {_gte: $date}'
		: 'isAvailable: {_eq: true}, jobPostStart: {_lte: $date}, jobPostEnd: {_gte: $date}'
}
				${eventId !== undefined ? `eventID: {_eq: ${eventId}},` : ''}
				${eventId !== undefined
		? 'JobPlatforms: {platform: {_in: ["VCF"]}}'
		: 'JobPlatforms: {platform: {_in: ["REGULAR"]}}'
}
				}, limit: ${limit}, offset: ${(page - 1) * limit}) {
        id
        title
        titleChinese
        titleMalay
        createdAt
        jobPostStart
        eventID
        JobHashTags {
          hashtag
          Hashtag {
            hashtag
            description
            color
          }
        }
        Company {
          name
          avatar
        }
        JobSalaries {
          min
          max
          jobType
          salaryType
        }
        Category {
          name
        }
      }
			Job_aggregate(where: {companyId: {_eq: ${companyId}}, 
				${eventId !== undefined
		? 'isAvailable: {_eq: false}, jobPostStart: {_lte: $date}, jobPostEnd: {_gte: $date}'
		: 'isAvailable: {_eq: true}, jobPostStart: {_lte: $date}, jobPostEnd: {_gte: $date}'
}
				${eventId !== undefined ? `eventID: {_eq: ${eventId}},` : ''}
				${eventId !== undefined
		? 'JobPlatforms: {platform: {_in: ["VCF"]}}'
		: 'JobPlatforms: {platform: {_in: ["REGULAR"]}}'
}
				}) {
					aggregate {
						count
					}
				}
      Company_by_pk(id: ${companyId}) {
        name
        description
        avatar
      }
    }`
		} else if (query.tab === 'about-us') {
			jobQuery = `
      query {
        Company_by_pk(id: ${companyId}) {
          name
          description
          avatar
          video
        }
      }`
		}
		const hasuraQuery = await client.query({
			query: `${jobQuery}`,
			variables:
				query.tab === 'jobs'
					? {
						date: new Date(),
					}
					: {},
		})

		const hasuraRes = await hasuraQuery
		const {
			data: { Company_by_pk: CompanyByPk },
		} = hasuraRes

		let jobAggregate = { aggregate: { count: 0 } }
		type Pagination = {
			prev: boolean;
			pagi: any[];
			next: boolean;
		};
		const pagination: Pagination = {
			prev: false,
			pagi: [],
			next: false,
		}
		if (query.tab === 'jobs') {
			jobAggregate = hasuraRes.data.Job_aggregate

			const currentPage = page
			if (currentPage > 1) {
				pagination.prev = true
			}

			const numOfPage = Math.ceil(jobAggregate?.aggregate?.count / 10)

			if (numOfPage < 6) {
				pagination.pagi = Array.from(Array(numOfPage), (e, i) => {
					return i + 1
				})
			} else {
				if (currentPage < 3) {
					pagination.pagi = Array.from(Array(3), (e, i) => {
						return i + 1
					})
					pagination.pagi.push('dotted')
					pagination.pagi.push(numOfPage)
				} else {
					const tempPagiItems: any[] = []

					if (currentPage - 1 > 1) {
						if (currentPage - 2 !== 1) {
							tempPagiItems.push(1)
							if (currentPage - 2 !== 1) {
								tempPagiItems.push('dotted')
							}
						}
						// tempPagiItems.push(currentPage - 2)
					}

					if (currentPage - 1 > 1) {
						tempPagiItems.push(currentPage - 1)
					}

					tempPagiItems.push(currentPage)
					if (currentPage + 1 <= numOfPage) {
						tempPagiItems.push(currentPage + 1)
					}
					if (currentPage + 2 <= numOfPage) {
						// tempPagiItems.push(currentPage + 2)
						if (currentPage + 2 !== numOfPage) {
							if (currentPage + 3 < numOfPage) {
								tempPagiItems.push('dotted')
							}
							tempPagiItems.push(numOfPage)
						}
					}

					pagination.pagi = tempPagiItems
				}
			}

			pagination.next = false
			if (currentPage < numOfPage) {
				pagination.next = true
			}
		}

		// Pass data to the page via props
		return {
			props: {
				...(await serverSideTranslations(locale as string, ['common'])),
				companyId: companyId,
				jobs: query.tab === 'jobs' ? hasuraRes.data.Job : [],
				jobAggregate: jobAggregate,
				company: CompanyByPk,
				tab: query.tab as string,
				eventId: eventId ? eventId : null,
				pagination,
				page,
			},
		}
	},
	sessionOptions,
)

export default Company
